import React, { useEffect, useState } from "react";
import AddUpdateUI from "./AddUpdateUI";
import { useDispatch, useSelector } from "react-redux";
import { getCities, getStates } from "../../../services/CommonServices";

const AddUpdateArtist = ({ showrole, formik, projectDetails }) => {
  const dispatch = useDispatch();
  const { data: states } = useSelector((state) => state.state);
  const { data: cities } = useSelector((state) => state.city);
  const [selectedRelationData, setSelectedRelationData] = useState({
    city: {},
    state: {},
  });
  useEffect(() => {
    dispatch(getStates());
    if (!formik.values.country_code) {
      formik.setFieldValue("countryCode", "+91");
    }
  }, []);
  // When states are loaded or editing an existing artist → set selected state
  useEffect(() => {
    if (states?.length && formik.values.state) {
      const matched = states.find((s) => s._id === formik.values.state);
      if (matched) {
        setSelectedRelationData((prev) => ({
          ...prev,
          state: { label: matched.name, value: matched._id },
        }));
        // also fetch cities for this state
        dispatch(getCities({ state: matched._id }));
        // setSelectedRelationData((prev) => ({
        //   ...prev,
        //   city: {},
        // }));
        // formik.setFieldValue("city", ""); // 🔑 make sure formik value is always string
      }
    }
  }, [states, formik?.values?.state]);

  // When cities are loaded or editing an existing artist → set selected city
  useEffect(() => {
    if (cities?.length && formik.values.city) {
      // If city is an object from backend, normalize it
      const cityId =
        typeof formik.values.city === "object"
          ? formik.values.city._id
          : formik.values.city;

      const matched = cities.find((c) => c._id === cityId);
      if (matched) {
        setSelectedRelationData((prev) => ({
          ...prev,
          city: { label: matched.name, value: matched._id },
        }));
        formik.setFieldValue("city", matched._id); // 🔑 make sure formik value is always string
      }
    }
  }, [cities, formik.values.city]);

  useEffect(() => {
    if (selectedRelationData.state.value) {
      dispatch(getCities({ state: selectedRelationData.state.value }));
      // also update formik value
      formik.setFieldValue("state", selectedRelationData.state.value);
    }
  }, [selectedRelationData?.state?.value]);

  // When user selects a city manually → update formik value
  useEffect(() => {
    if (selectedRelationData.city?.value) {
      formik.setFieldValue("city", selectedRelationData.city.value); // ✅ only store ID
    }
  }, [selectedRelationData.city]);

  // detect lead artist
  const isLeadArtist =
    projectDetails?.artist?._id &&
    formik.values?._id === projectDetails.artist._id;

  return (
    <AddUpdateUI
      formik={formik}
      selectedRelationData={selectedRelationData}
      setSelectedRelationData={setSelectedRelationData}
      isLeadArtist={isLeadArtist}
      showrole={showrole ?? true}
    />
  );
};

export default AddUpdateArtist;
